import { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import { FAQ } from "../content/site";
import s from "./Faq.module.css";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="section" aria-labelledby="faq-title">
      <div className={`container ${s.layout}`}>
        <div>
          <p className="eyebrow">Časté dotazy</p>
          <h2 id="faq-title" className="h2" style={{ marginTop: 12 }}>Co zajímá většinu zákazníků</h2>
          <p className="muted" style={{ marginTop: 16 }}>
            Nenašli jste odpověď?{" "}
            <Link to="/kontakt" className="link-arrow">Napište nám <Icon name="arrow-right" size={16} /></Link>
          </p>
        </div>

        <div className={s.list}>
          {FAQ.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className={s.item}>
                <h3>
                  <button
                    type="button" className={s.question}
                    aria-expanded={isOpen} aria-controls={`faq-${i}`} id={`faq-q-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                  >
                    {item.q}
                    <Icon name="chevron-down" size={20} className={`${s.chevron} ${isOpen ? s.rotated : ""}`} />
                  </button>
                </h3>
                <div id={`faq-${i}`} role="region" aria-labelledby={`faq-q-${i}`} hidden={!isOpen} className={s.answer}>
                  <p>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
